// Card Status: merge card validity + most-recent-charge health so a valid card
// no longer hides a declined charge.

export type CardStatusTone = "ok" | "warn" | "bad";

export interface CardStatusView {
  label: string;
  tone: CardStatusTone;
  tooltip: string;
}

export function deriveCardStatus(input: {
  paymentMethodStatus: string | null;
  latestChargeStatus: string | null;
  failedChargeCount: number | null;
}): CardStatusView | null {
  const { paymentMethodStatus, latestChargeStatus } = input;
  const failedCount = input.failedChargeCount ?? 0;

  // Order mirrors backend computeBillingStatusPill: card problem before declined charge. Keep in sync.
  if (paymentMethodStatus === "none") {
    return { label: "No Card", tone: "bad", tooltip: "No default card on file in Stripe." };
  }

  if (paymentMethodStatus === "expired") {
    return { label: "Card expired", tone: "bad", tooltip: "Card on file has expired — needs an update." };
  }

  if (latestChargeStatus === "failed") {
    const tooltip =
      failedCount > 1
        ? `Most recent charge declined (${failedCount} failed charges).`
        : "Most recent charge declined.";
    return { label: "Charge declined", tone: "bad", tooltip };
  }

  if (paymentMethodStatus === "expiring_soon") {
    return { label: "Expiring soon", tone: "warn", tooltip: "Card on file expires within 60 days." };
  }

  if (paymentMethodStatus === "ok") {
    return { label: "OK", tone: "ok", tooltip: "Card on file, no issues." };
  }

  // null / "unknown" / anything else → not enough data to judge
  return null;
}
